import useGetPrivateOrganizationInfoReportList from '@/hooks/api/useGetPrivateOrganizationInfoReportList';
import useSetLoading from '@/hooks/useSetLoading';
import alertState from '@/states/alertState';
import { PrivateOrganizationInfoReportListState } from '@/states/privateOrganizationInfoReportListState';
import { PrivateOrganizationInfoReportListResponse } from '@/types/api/mypage/privateOrganizationInfoReportList';
import { isExpiredToken } from '@/utils/cognito';
import url from '@/utils/config';
import { ApiUrl, Constants } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import AccordionButton from '../atoms/AccordionButton';
import Heading from '../atoms/Heading';

/**
 * Hands-up 活動報告書
 * @returns コンポーネント
 */
const HandsupPoReportInfoTable = () => {
  const setAlert = useSetRecoilState(alertState);
  const { startLoading, finishLoading } = useSetLoading();

  // 全件表示
  const [isDisplayAll, setIsDisplayAll] = useState(false);

  // 任意団体活動報告書一覧
  const [privateOrganizationInfoReportList, setPrivateOrganizationInfoReportList] = useRecoilState(
    PrivateOrganizationInfoReportListState
  );

  const { execute: getPrivateOrganizationInfoReportList } =
    useGetPrivateOrganizationInfoReportList();

  useEffect(() => {
    callAPIGetPrivateOrganizationInfoReportList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 任意団体活動報告書一覧取得API呼び出し
  const callAPIGetPrivateOrganizationInfoReportList = async () => {
    try {
      startLoading(ApiUrl.Read.PRIVATE_ORGANIZATION_INFO_REPORT_LIST);
      const { data }: AxiosResponse<PrivateOrganizationInfoReportListResponse, any> =
        await getPrivateOrganizationInfoReportList();

      // 取得した値をセット
      setPrivateOrganizationInfoReportList(data.report_info);
    } catch (error: any) {
      if (isExpiredToken(error)) {
        sessionStorage.clear();
        window.location.href = url('/login');
        return;
      }
      setAlert({
        isOpen: true,
        apiType: Constants.ApiType.API_GET,
      });
    } finally {
      finishLoading(ApiUrl.Read.PRIVATE_ORGANIZATION_INFO_REPORT_LIST);
    }
  };

  return (
    <>
      <Heading as='h3'>Hands-up&emsp;活動報告書</Heading>
      <div className='m-table'>
        {privateOrganizationInfoReportList?.length ? (
          <>
            <table>
              <colgroup>
                <col />
                <col />
              </colgroup>
              <tbody>
                {privateOrganizationInfoReportList
                  .filter(
                    (_, index) =>
                      isDisplayAll || index < Constants.PrivateOrganizationInfoReportList.MAX
                  )
                  .map((poReport) => (
                    <tr key={poReport.report_date}>
                      <th
                        className='m-table__th'
                        data-testid={`poreport_name_${poReport.report_date}`}
                      >
                        {poReport.display_name}
                      </th>
                      <td className='m-table__td'>
                        <Link
                          href={`/contract/poreport/?reportDate=${poReport.report_date}`}
                          data-testid={`poreport_link_${poReport.report_date}`}
                        >
                          表示
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {privateOrganizationInfoReportList?.length >
              Constants.PrivateOrganizationInfoReportList.MAX && (
              <AccordionButton
                label={{ open: '全件表示', close: '省略表示' }}
                isDisplay={isDisplayAll}
                onClick={() => {
                  setIsDisplayAll(!isDisplayAll);
                }}
              />
            )}
          </>
        ) : (
          <p className='m-text'>ご参照可能な活動報告書はまだ存在しません。</p>
        )}
      </div>
    </>
  );
};

export default HandsupPoReportInfoTable;
